import { cva } from '@/styled-system/css';

export const cardFooterRecipe = cva({
  base: {
    marginBlockStart: 'Card.Footer.margin.to-Body',
  },
  variants: {
    divider: {
      true: {
        paddingBlockStart: 'Card.Footer.padding.from-Footer',
        borderBlockStartWidth: 'Card.Footer',
        borderBlockStartStyle: 'solid',
        borderBlockStartColor: 'Card.Footer.border',
      },
      false: {},
    },
  },
});
